module.exports = __webpack_public_path__ + "img/defult.3587dc3a.png";